import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  IconButton, Icon, Paper, Button,
} from '@material-ui/core';
import { uploadImageStyle } from '../../css/style';

const styles = uploadImageStyle();

class UploadImage extends Component {
  constructor(props) {
    super(props);
    this.state = { image: props.image };
    this.fileInput = React.createRef();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.image !== this.props.image) {
      this.setState({ image: this.props.image });
    }
  }

  onChooseFile = () => {
    const { onChangeInput, allowMultiple } = this.props;
    const file = this.fileInput.current.files[0];
    const reader = new FileReader();
    let fileBase64;
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      fileBase64 = reader.result;
      onChangeInput(fileBase64);
    };
  }

  onDeleteFile = (base64Url, index) => {
    const { onDeleteImage } = this.props;
    onDeleteImage(base64Url, index);
  }

  addPhotoInput = () => (
    <label htmlFor='addPhoto' style={styles.addPhotoButton}>
      ADD PHOTO
      <input
        id='addPhoto'
        type='file'
        ref={this.fileInput}
        onChange={this.onChooseFile}
        style={styles.hiddenChooseFile}
        disabled={this.props.disabled}
      />
    </label>
  )

  render() {
    const { type, index, disabled } = this.props;
    return (
      (this.state.image)
        ? (
          <div style={styles.imageContainer}>
            <img src={this.state.image} style={styles.imageStyle} alt="resource" />
            {
              type !== 'view' && !disabled
              && (
                <IconButton
                  style={styles.closeButton}
                  onClick={() => this.onDeleteFile(this.state.image, index)}
                >
                  <Icon>close</Icon>
                </IconButton>
              )
            }
          </div>
        )
        : (
          <div style={styles.imageContainer}>
            <Paper style={styles.imagePlaceholder}>
              {!disabled && this.addPhotoInput()}
            </Paper>
          </div>
        )
    );
  }
}

UploadImage.propTypes = {
  image: PropTypes.string,
  allowMultiple: PropTypes.bool,
  type: PropTypes.string,
  onChangeInput: PropTypes.func.isRequired,
  onDeleteImage: PropTypes.func,
};

UploadImage.defaultProps = {
  image: null,
  allowMultiple: false,
  type: null,
  onDeleteImage: () => { },
};

export default UploadImage;
